<template>
    <div id="add-year-of-study">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :color="primaryColor" dark small v-bind="attrs" v-on="on"
                    @click.stop="openAddYearOfStudyDialog()">
                    <v-icon>mdi-calendar-plus</v-icon>
                </v-btn>
            </template>
            <span>Add Year of Study</span>
        </v-tooltip>
        <v-dialog v-model="addYearOfStudyDialog" max-width="576" persistent>
            <v-card>
                <v-card-title>
                    Add Year of Study
                </v-card-title>
                <v-card-text>
                    <v-form ref="addYearOfStudyForm" v-model="valid" lazy-validation>
                        <v-text-field v-model="currentYearOfStudy.year" clearable label="Year" :rules="yearRules"
                            required>
                        </v-text-field>
                        <v-text-field v-model="currentYearOfStudy.label" clearable label="Label" 
                        hint="This is the text that applicants see in their ORA form" required>
                        </v-text-field>
                        <v-select v-model="currentYearOfStudy.default"
                            hint="Set as default choice for the Online Residence Application form" :items="defaultItems"
                            label="Default" persistent-hint :rules="defaultRules" required>
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="addBtn" class="white--text" :color="successColor" :disabled="!valid"
                        @click="openAddYearOfStudyConfirmationDialog()">
                        Add
                    </v-btn>
                    <v-btn ref="closeBtn" :color="warningColor" @click="closeAddYearOfStudyDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addYearOfStudyConfirmationDialog" max-width="540">
            <v-card ref="addYearOfStudyConfirmationCard">
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Are you sure you would like to add <b>{{ currentYearOfStudy.year }}</b> as a Year of Study? Please
                    click
                    confirm to proceed.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="confirmBtn" :color="dangerColor" text @click="addYearOfStudy()">
                        Confirm
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeAddYearOfStudyConfirmationDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'year-of-study-add',
    data() {
        return {
            addYearOfStudyDialog: false,
            addYearOfStudyConfirmationDialog: false,
            currentYearOfStudy: {
                default: '0',
                year: '',
                label: ''
            },
            defaultItems: [{
                    text: 'Yes',
                    value: '1'
                },
                {
                    text: 'No',
                    value: '0'
                }
            ],
            defaultRules: [
                v => !(v === "") || 'Default is required',
            ],
            yearRules: [
                v => !!v || 'Year is required'
            ],
            valid: true
        }
    },
    methods: {
        addYearOfStudy() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateEntity`;

            // Parse array into string
            formData.append('data', JSON.stringify(this.currentYearOfStudy));
            formData.append('mode', 'updateEntity');
            formData.append('type', 'YearOfStudy');

            // Loading icon
            this.$refs.confirmBtn.loading = true;

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentYearOfStudy.year} has been successfully added as a Year of Study.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentYearOfStudy.year} could not be added as a Year of Study. Please contact your system administrator.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeAddYearOfStudyConfirmationDialog();
                    that.closeAddYearOfStudyDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        closeAddYearOfStudyConfirmationDialog() {
            this.addYearOfStudyConfirmationDialog = false;
        },
        closeAddYearOfStudyDialog() {
            this.addYearOfStudyDialog = false;
        },
        openAddYearOfStudyConfirmationDialog() {
            // Validate form before confirmation
            if (this.$refs.addYearOfStudyForm.validate()) {
                this.addYearOfStudyConfirmationDialog = true;
            }
        },
        openAddYearOfStudyDialog() {
            // Reset form
            this.resetForm();
            this.addYearOfStudyDialog = true;
        },
        resetForm() {
            // Reset form validation
            this.resetFormValidation();

            // Reset current year of study
            this.currentYearOfStudy.default = '0';
            this.currentYearOfStudy.year = '';
        },
        resetFormValidation() {
            if (this.$refs.addYearOfStudyForm) {
                this.$refs.addYearOfStudyForm.resetValidation();
            }
        },
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>